
export const PROJECT_NAME = location.pathname.replace(/\/[^/]+$/, '/');
